// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:atUsername\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"atUsername\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/encryption-demo\"},{\"path\":\"/examples\"},{\"path\":\"/feed\"},{\"path\":\"/friends\"},{\"path\":\"/posthog-example-page\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/signin\"},{\"path\":\"/signup\"}]}";globalThis["_sentryNextJsVersion"] = "16.0.9";import * as Sentry from "@sentry/nextjs"
import posthog from "posthog-js"

if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: "/relay-wYbT",
    ui_host: "https://us.posthog.com",
    defaults: "2025-05-24",
  })
}

Sentry.init({
  dsn: "https://c2e25ff2aa790f0396d3120cb501e790@o4509971197132800.ingest.us.sentry.io/4509971243466752",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
